export default {
  sections: {
    asap_orders: {
      title: 'Ordini immediati',
      fields: {
        has_live_orders: {
          label: 'Ordini live',
          tooltip: 'Attiva questa opzione solo quando il ristorante è pronto ad accettare ordini',
        },
        has_asap_orders: {
          label: 'Consenti ai clienti di effettuare ordini immediati?',
          tooltip: '*Gli ordini immediati si basano sul tuo tempo di preparazione',
        },
      },
    },
    scheduled_orders: {
      title: 'Ordini programmati',
      fields: {
        has_scheduled_orders: {
          label: 'Consenti ai clienti di ordinare in anticipo per orari specifici?',
        },
        has_pre_order: {
          label: 'Consenti ai clienti di ordinare con più di un giorno di anticipo?',
        },
        max_pre_order_days: {
          label: 'Massimo giorni di anticipo per gli ordini',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Notifiche promemoria ordini programmati',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Fasce orarie in minuti',
          option: 'Fascia da {{value}} minuti',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Aggiungi quantità massima ordini per fascia oraria',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Quantità massima ordini per fascia oraria',
          placeholder: '5',
        },
        order_instructions_title: {
          label: "Istruzioni per l'ordine",
          placeholder: "Inserisci istruzioni per l'ordine",
        },
        scheduled_order_option_title: {
          label: 'Titolo opzione programma per dopo',
          placeholder: 'Programma per dopo',
        },
      },
    },
    other: {
      title: 'Altro',
      fields: {
        order_approval_time_step: {
          label: 'Aggiunta / riduzione tempo ordine confermato',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Aggiungi minuti extra al tempo confermato',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Salva',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Questo ristorante è stato sospeso',
      description:
        'Per tornare live, vai alla <a>pagina abbonamento</a> e riattiva il ristorante; poi potrai abilitare gli ordini live in questa pagina.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      "Almeno 1 metodo d'ordine (programmato o immediato) deve essere attivo. Non puoi disabilitarli entrambi.",
  },
};
